import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import FormsExtensionHero from './components/FormsExtensionHero';
import FormsExtensionFeatures from './components/FormsExtensionFeatures';
import FormsExtensionBenefits from './components/FormsExtensionBenefits';
import FormsExtensionPricing from './components/FormsExtensionPricing';
import FormsExtensionTrial from './components/FormsExtensionTrial';
import Footer from '../home/components/Footer';

const PDFFormsExtensionSDKPage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    document.title = 'PDF表单扩展SDK - 智能表单处理工具 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'PDF表单扩展SDK提供智能表单处理功能，支持表单识别、数据提取、自动填充、字段验证等，提升表单处理效率，适用于各类业务场景。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'PDF表单,表单SDK,智能表单,表单识别,数据提取,自动填充,表单处理');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/pdf-forms-extension-sdk`);

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "PDF表单扩展SDK",
      "applicationCategory": "BusinessApplication",
      "description": "智能表单处理工具，支持表单识别、数据提取、自动填充等功能",
      "url": `${siteUrl}/pdf-forms-extension-sdk`,
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "CNY",
        "price": "按需定制"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.7",
        "reviewCount": "52"
      },
      "provider": {
        "@type": "Organization",
        "name": "星允信息科技有限公司"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FormsExtensionHero />
      <FormsExtensionFeatures />
      <FormsExtensionBenefits />
      <FormsExtensionPricing />
      <FormsExtensionTrial />
      <Footer />
    </div>
  );
};

export default PDFFormsExtensionSDKPage;
